export default function HumanGold () {
    return (
        <div className="m-5 p-3">
            <p>Fejlesztés alatt</p>
        </div>
    )
}
